import { useCallback } from 'react';

const useOpenUrlInNewTab = () => {

  return useCallback((url) => {
    if (!url) {
      return;
    }

    window.open(url, "_blank", "noopener,noreferrer");
  }, []);
};

export default useOpenUrlInNewTab;